/**
 * Login
 * @desc Login page logic
 */

const Login = (function () {
  // Local, but exposed object
  const module = {};
  
  // Private variables

  // Basic functions for the login page
  // Excluded from any SPA logic
  let login = document.getElementById('login');
  let loginForm = document.getElementById('loginForm');
  let rememberMe = document.getElementById('rememberMe');
  let email = document.getElementById('email');
  let password = document.getElementById('password');
  let rememberMeValue = localStorage.getItem('rememberMe');

  function showForgotPassword () {
    sessionStorage.setItem('forgotPassword', true);
    login.classList.add('c-login--forgot-password');
  }

  function showLogin () {
    sessionStorage.removeItem('forgotPassword');
    login.classList.remove('c-login--forgot-password');
  }

  /**
   * Init Function
   * @desc Initialises the login module logic
   */
  module.init = function() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      // Explicitly set the meta viewport width and height
      // This resolves issues on some mobile devices where soft keyboards alter the viewport which causes layout issues
      let viewheight = window.outerHeight;
      let viewwidth = window.outerWidth;
      let viewport = document.querySelector('meta[name=viewport]');

      viewport.setAttribute('content', 'height=' + viewheight + 'px, width=' + viewwidth + 'px, initial-scale=1, maximum-scale=1, user-scalable=no');
    }

    // Remember me
    if (rememberMeValue) {
      document.getElementById('welcome').classList.remove('is-hidden');
      rememberMe.checked = true;
      email.value = rememberMeValue;
      password.focus();
    } else {
      email.focus();
    }

    document.getElementById('loginForm').addEventListener('submit', function () {
      if (rememberMe.checked) {
        localStorage.setItem('rememberMe', email.value);
      } else {
        if (rememberMeValue) {
          localStorage.removeItem('rememberMe');
        }
      }
    });

    // Forgot password
    if (sessionStorage.getItem('forgotPassword')) {
      showForgotPassword();
    }

    document.getElementById('showForgotPassword').addEventListener('click', (e) => {
      e.preventDefault();
      showForgotPassword();
    });

    document.getElementById('showLogin').addEventListener('click', (e) => {
      e.preventDefault();
      showLogin();
    });

    // TODO: Create class based selector so we don't have duplicate code
    document.getElementById('join').addEventListener('click', (e) => {
      e.preventDefault();
      window.TriggerVueExitLogin();    
    });  
  };

  return module;
}());

Login.init();



// WEBPACK FOOTER //
// ./resources/assets/js/external/login.js